/* Motus 21.10.2026: rich content Barel na karcie produktu (snippets/motus-rc.liquid). Wersja 3 (po kontroli PC BACKUP).
   1) Shadow DOM: przeglądarka sama podpina <template shadowrootmode="open"> przy parsowaniu strony. Gdy nie (stara przeglądarka
      albo sekcja przeładowana w edytorze motywu przez innerHTML), podpinamy tu z tej samej treści.
   2) Filmy LP (video[data-rc-auto]): w HTML bez autoplay i z preload="none", więc nic się nie pobiera na starcie.
      Film rusza, gdy jest do 300 px od okna, i pauzuje poza nim. Kliknięcie filmu: pauza / wznowienie (pauza klienta zostaje,
      także po powrocie filmu na ekran). Przy prefers-reduced-motion filmy stoją na plakacie, kliknięcie je włącza.
      Przycisk "Zatrzymaj filmy" (WCAG 2.2.2) jest ukryty wizualnie i pokazuje się przy przejściu klawiszem Tab.
   3) Plakaty filmów (data-rc-plakat) podpinamy dopiero ok. 800 px przed oknem: LP zaczyna się niżej niż pierwszy ekran.
   4) Kotwice LP (a[href="#id"]) z celem wewnątrz Shadow DOM: przeglądarka szuka celu tylko w dokumencie, więc przewijamy stronę
      sami, z odstępem na przyklejony nagłówek motywu (jak pasek kotwic Concept: wysokość nagłówka + 20 px).
      Kotwica "#__klucz" = sekcja szablonu o tym kluczu poza LP (jak w pasku kotwic, motus-custom.js sekcja 5), np. "Zobacz parametry"
      -> #__product-details, gdy snippet chowa tabelę specyfikacji LP (uwagi Barel 2.2, 02.11.2026).
   5) Nasłuchy w shadow root podpinamy raz na element. Odpięcie i ponowne podpięcie hosta (edytor motywu, przeniesienie w DOM)
      tylko zatrzymuje i wznawia obserwatory; pauza klienta zostaje.
   6) Źródło filmu (przed pierwszym odtworzeniem): src = oryginał z Files (bajty LP Barel), data-rc-sd = największa wersja Shopify
      (480p/720p). Wersję Shopify bierzemy, gdy min(szerokość oryginału, okno) <= jej szerokość <= szerokość oryginału: na telefonie
      zwykle tak, na komputerze tylko dla filmów szerszych od okna (lights 1920 -> 1570 przy 1440). Wersji powiększonej z oryginału
      (angle, speed: 600 -> 960) nie bierzemy nigdy. Błąd oryginału (np. Safari odrzuci application/octet-stream) = wersja Shopify.
      Układ od pliku nie zależy: rozmiar naturalny filmu daje contain-intrinsic-size z RC-BAZA (--rc-w/--rc-h ze snippetu).
   7) 21.10.2026 (egzoszkielety z Figmy): przycisk zatrzymania stawia na hoście atrybut data-rc-stop, a CSS LP pauzuje nim
      animacje (pasek zastosowań co 5 s). LP z [data-rc-anim] ma przycisk "Zatrzymaj animacje" zamiast "Zatrzymaj filmy".
   8) Okno poszerzone po wyborze (obrót telefonu, większe okno): wersja Shopify, która stała się za wąska, wraca na oryginał
      (tylko w tę stronę i nie po błędzie oryginału). Film poza oknem dostaje preload="none", więc nic się wtedy nie pobiera.
   9) 21.10.2026 (Scooty 8.5, LP z Parcel): karuzela Splide ([data-splide] z adresem biblioteki w data-rc-splide-js, plik LP
      w Files). Bibliotekę pobieramy raz na stronę i uruchamiamy w zasięgu funkcji (module/exports), więc nie zostawia zmiennych
      globalnych (window.Splide i pomocnicze z paczki LP). new Splide(el).mount() na elemencie w shadow root, opcje Splide czyta
      sam z data-splide. Autoplay karuzeli: stoi przy prefers-reduced-motion i po "Zatrzymaj animacje" (ten sam przycisk co
      filmy, WCAG 2.2.2); najechanie i fokus pauzują jak w oryginale. Bez biblioteki (błąd sieci albo CSP bez eval) karuzela
      dostaje klasę rc-bez-splide, lista slajdów się zawija, a slajdy klasy is-visible i is-active (CSS LP rysuje je jak slajd
      na widoku), więc wszystkie stoją w rzędach zamiast jednego rzędu uciętego przez tor; przycisk znika, gdy nic się nie rusza.
  10) 21.10.2026 (kontrola rodziny D): przy prefers-reduced-motion filmy i karuzela stoją od startu, więc przycisk startuje
      jako "Wznów ..." z aria-pressed="true" (host z data-rc-stop); pierwsze kliknięcie włącza ruch. */
(() => {
  if (customElements.get('motus-rc')) return;
  const ruchMniej = window.matchMedia('(prefers-reduced-motion: reduce)');
  const bibliotekiSplide = new Map();
  const ladujSplide = (url) => {
    if (!bibliotekiSplide.has(url)) {
      bibliotekiSplide.set(url, fetch(url)
        .then((r) => { if (!r.ok) throw new Error('motus-rc: Splide HTTP ' + r.status); return r.text(); })
        .then((kod) => {
          /* UMD paczki: przy module/exports zwraca konstruktor w module.exports, bez window.Splide i bez define (AMD) */
          const modul = { exports: {} };
          new Function('module', 'exports', 'define', kod)(modul, modul.exports, undefined); // eslint-disable-line no-new-func
          if (typeof modul.exports !== 'function') throw new Error('motus-rc: Splide bez konstruktora');
          return modul.exports;
        }));
    }
    return bibliotekiSplide.get(url);
  };

  class MotusRc extends HTMLElement {
    connectedCallback() {
      if (!this.rcRoot && !this.przygotuj()) return;
      this.wlacz();
    }

    disconnectedCallback() {
      this.wylacz();
    }

    przygotuj() {
      let root = this.shadowRoot;
      if (!root) {
        const t = this.querySelector(':scope > template[shadowrootmode]');
        if (!t) return false;
        root = this.attachShadow({ mode: 'open' });
        root.appendChild(t.content);
        t.remove();
      }
      this.rcRoot = root;
      this.filmy = Array.from(root.querySelectorAll('video[data-rc-auto]'));
      this.zPlakatem = Array.from(root.querySelectorAll('video[data-rc-plakat]'));
      this.pauzaKlienta = new WeakSet();
      this.wOknie = new WeakSet();
      this.wszystkoStop = false;
      this.filmy.forEach((v) => {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.addEventListener('error', () => this.naBlad(v));
      });
      root.addEventListener('click', (e) => this.naKlik(e));
      this.karuzele = Array.from(root.querySelectorAll('[data-splide][data-rc-splide-js]'));
      this.maAnimacje = !!root.querySelector('[data-rc-anim]') || this.karuzele.length > 0;
      this.przycisk = root.querySelector('.rc-pauza');
      if (this.przycisk && (this.filmy.length || this.karuzele.length)) {
        this.wszystkoStop = ruchMniej.matches; /* 10) przy ograniczonym ruchu nic nie rusza samo: przycisk = "Wznów" */
        this.przycisk.hidden = false;
        this.przycisk.addEventListener('click', () => this.naPrzycisk());
        this.odswiezPrzycisk();
      }
      this.naWidocznosc = () => this.filmy.forEach((v) => this.ustaw(v));
      this.naRozmiar = () => {
        clearTimeout(this.tRozmiar);
        this.tRozmiar = setTimeout(() => this.filmy.forEach((v) => this.przelicz(v)), 300);
      };
      return true;
    }

    wlacz() {
      if (this.rcWlaczone) return;
      this.rcWlaczone = true;
      const bezPlakatu = this.zPlakatem.filter((v) => !v.hasAttribute('poster'));
      if (bezPlakatu.length) {
        this.obsPlakatow = new IntersectionObserver((wpisy) => {
          wpisy.forEach((w) => {
            if (!w.isIntersecting) return;
            this.dajPlakat(w.target);
            this.obsPlakatow.unobserve(w.target);
          });
        }, { rootMargin: '800px 0px' });
        bezPlakatu.forEach((v) => this.obsPlakatow.observe(v));
      }
      if (this.filmy.length) {
        this.obserwator = new IntersectionObserver((wpisy) => {
          wpisy.forEach((w) => {
            if (w.isIntersecting) this.wOknie.add(w.target); else this.wOknie.delete(w.target);
            this.ustaw(w.target);
          });
        }, { rootMargin: '300px 0px' });
        this.filmy.forEach((v) => this.obserwator.observe(v));
        document.addEventListener('visibilitychange', this.naWidocznosc);
        window.addEventListener('resize', this.naRozmiar, { passive: true });
      }
      this.uruchomKaruzele();
      this.karuzele.forEach((el) => this.ruchKaruzeli(el));
    }

    wylacz() {
      if (!this.rcWlaczone) return;
      this.rcWlaczone = false;
      if (this.obsPlakatow) this.obsPlakatow.disconnect();
      if (this.obserwator) this.obserwator.disconnect();
      this.obsPlakatow = null;
      this.obserwator = null;
      document.removeEventListener('visibilitychange', this.naWidocznosc);
      window.removeEventListener('resize', this.naRozmiar);
      clearTimeout(this.tRozmiar);
      this.wOknie = new WeakSet();
      this.filmy.forEach((v) => { if (!v.paused) v.pause(); });
      this.karuzele.forEach((el) => this.ruchKaruzeli(el));
    }

    uruchomKaruzele() {
      if (this.karuzeleStart || !this.karuzele.length) return;
      this.karuzeleStart = true;
      this.karuzele.forEach((el) => {
        ladujSplide(el.getAttribute('data-rc-splide-js')).then((Splide) => {
          if (el.rcSplide) return;
          el.rcSplide = new Splide(el).mount();
          this.ruchKaruzeli(el);
        }).catch((blad) => {
          this.bezBiblioteki(el);
          console.warn(blad);
        });
      });
    }

    /* 9) bez biblioteki: wszystkie slajdy na widoku (rzędy), a nie jeden rząd ucięty przez .splide__track{overflow:hidden} */
    bezBiblioteki(el) {
      if (el.rcSplide || el.rcBezSplide) return;
      el.rcBezSplide = true;
      el.classList.add('rc-bez-splide');
      el.style.visibility = 'visible'; /* .splide{visibility:hidden} do inicjalizacji */
      el.querySelectorAll('.splide__list').forEach((l) => { l.style.flexWrap = 'wrap'; });
      el.querySelectorAll('.splide__slide').forEach((s) => s.classList.add('is-visible', 'is-active'));
      const animCss = !!this.rcRoot.querySelector('[data-rc-anim]');
      this.maAnimacje = animCss || this.karuzele.some((k) => !k.rcBezSplide);
      if (this.przycisk && !this.filmy.length && !animCss && this.karuzele.every((k) => k.rcBezSplide)) this.przycisk.hidden = true;
      this.odswiezPrzycisk();
    }

    ruchKaruzeli(el) {
      const s = el.rcSplide;
      const a = s && s.Components && s.Components.Autoplay;
      if (!a || !s.options.autoplay) return;
      if (this.rcWlaczone && !this.wszystkoStop && (!ruchMniej.matches || this.ruchOdKlienta)) a.play();
      else a.pause();
    }

    dajPlakat(v) {
      const p = v.getAttribute('data-rc-plakat');
      if (p && !v.hasAttribute('poster')) v.setAttribute('poster', p);
    }

    naKlik(e) {
      if (!(e.target instanceof Element)) return;
      const a = e.target.closest('a[href^="#"]');
      if (a) { this.doKotwicy(e, a); return; }
      const v = e.target.closest('video[data-rc-auto]');
      if (!v) return;
      if (v.paused) { this.pauzaKlienta.delete(v); this.wszystkoStop = false; this.graj(v, true); }
      else { this.pauzaKlienta.add(v); v.pause(); }
      this.odswiezPrzycisk();
    }

    naPrzycisk() {
      this.wszystkoStop = !this.wszystkoStop;
      if (!this.wszystkoStop) this.ruchOdKlienta = true;
      this.filmy.forEach((v) => {
        if (this.wszystkoStop) v.pause();
        else { this.pauzaKlienta.delete(v); this.ustaw(v, true); }
      });
      this.karuzele.forEach((el) => this.ruchKaruzeli(el));
      this.odswiezPrzycisk();
    }

    doKotwicy(e, a) {
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      let id = a.getAttribute('href').slice(1);
      try { id = decodeURIComponent(id); } catch (_) { /* zostaje surowe */ }
      if (!id) return;
      let cel = this.rcRoot.getElementById(id) || this.rcRoot.querySelector(`a[name="${CSS.escape(id)}"]`);
      if (!cel && id.startsWith('__')) cel = document.querySelector(`.shopify-section[id$="${CSS.escape(id)}"]`);
      if (!cel) return; /* cel poza LP (sekcja motywu): zwykłe przejście przeglądarki */
      e.preventDefault();
      const y = cel.getBoundingClientRect().top + window.scrollY - this.odstepGorny(cel);
      window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: ruchMniej.matches ? 'auto' : 'smooth' });
      if (e.detail === 0) {
        /* przejście z klawiatury: fokus na cel, żeby kolejny Tab szedł dalej od celu */
        if (!cel.hasAttribute('tabindex') && !cel.matches('a[href],button,input,select,textarea,summary')) cel.setAttribute('tabindex', '-1');
        cel.focus({ preventScroll: true });
      }
    }

    odstepGorny(cel) {
      let h = 20;
      const naglowek = document.querySelector('.header-section header[is="sticky-header"]');
      /* telefon: nagłówek chowa się przy przewijaniu w dół (motus-wzor-naglowek-stopka.css), więc przy celu poniżej nie zajmuje miejsca */
      const chowaSie = getComputedStyle(document.documentElement).getPropertyValue('--motus-naglowek-chowa-sie').trim() === '1';
      const wDol = cel.getBoundingClientRect().top > 0;
      if (naglowek && !(chowaSie && wDol)) h += naglowek.getBoundingClientRect().height;
      const pasek = document.querySelector('.scrollspy-section');
      if (pasek) {
        const poz = getComputedStyle(pasek).position;
        if (poz === 'sticky' || poz === 'fixed') h += pasek.getBoundingClientRect().height;
      }
      return h;
    }

    /* true = wersja Shopify wystarcza: nie węższa niż miejsce na film i nie powiększona z oryginału */
    wystarczySd(v) {
      const sdW = parseInt(v.getAttribute('data-rc-sd-w'), 10) || 0;
      if (!sdW) return false;
      const cs = getComputedStyle(v);
      const orgW = parseInt(cs.getPropertyValue('--rc-w'), 10) || parseInt(cs.getPropertyValue('--rc-ar'), 10) || 0;
      if (orgW && sdW > orgW) return false;
      return sdW >= Math.min(orgW || Infinity, document.documentElement.clientWidth || window.innerWidth);
    }

    wybierzZrodlo(v) {
      if (v.rcZrodlo) return;
      v.rcZrodlo = true;
      const sd = v.getAttribute('data-rc-sd');
      if (!sd) return;
      v.rcOrg = v.getAttribute('src');
      if (this.wystarczySd(v)) v.setAttribute('src', sd);
    }

    przelicz(v) {
      const sd = v.getAttribute('data-rc-sd');
      if (!v.rcZrodlo || v.rcBlad || !sd || !v.rcOrg || v.getAttribute('src') !== sd || this.wystarczySd(v)) return;
      if (!this.wOknie.has(v)) v.preload = 'none';
      v.setAttribute('src', v.rcOrg);
      this.ustaw(v);
    }

    naBlad(v) {
      const sd = v.getAttribute('data-rc-sd');
      if (!sd || v.getAttribute('src') === sd) return;
      v.rcBlad = true;
      v.rcZrodlo = true;
      v.setAttribute('src', sd);
      v.load();
      /* play() dopiero po krokach błędu oryginału: wywołane w obsłudze zdarzenia error dostaje NotSupportedError (przeglądarka
         odrzuca wtedy oczekujące play()), a catch w graj() pauzuje film na plakacie (fix-B2 22.10, test z zablokowanym /c/o/v/) */
      setTimeout(() => this.ustaw(v), 0);
    }

    graj(v, odKlienta) {
      this.dajPlakat(v);
      this.wybierzZrodlo(v);
      if (v.preload !== 'auto') v.preload = 'auto';
      const p = v.play();
      if (p && p.catch) p.catch(() => { if (!odKlienta) v.pause(); });
    }

    ustaw(v, odKlienta) {
      const moze = this.wOknie.has(v) && !document.hidden && !this.wszystkoStop && !this.pauzaKlienta.has(v);
      if (moze && (!ruchMniej.matches || odKlienta)) this.graj(v, odKlienta);
      else if (!v.paused) v.pause();
    }

    odswiezPrzycisk() {
      if (!this.przycisk) return;
      this.toggleAttribute('data-rc-stop', this.wszystkoStop);
      const co = this.maAnimacje ? 'animacje' : 'filmy';
      this.przycisk.textContent = (this.wszystkoStop ? 'Wznów ' : 'Zatrzymaj ') + co;
      this.przycisk.setAttribute('aria-pressed', this.wszystkoStop ? 'true' : 'false');
    }
  }

  customElements.define('motus-rc', MotusRc);
  /* Edytor motywu: sekcja przeładowana przez innerHTML wstawia nowy <motus-rc>, connectedCallback podpina go sam. */
})();
